// utils/examStorageHelper.js

export function getExamStorage(isRealExam) {
    return isRealExam ? localStorage : sessionStorage;
}

export function getItemFromExamStorage(key, isRealExam) {
    try {
        const raw = getExamStorage(isRealExam).getItem(key);
        // console.log(raw);

        // console.log(JSON.parse(raw));

        return JSON.parse(raw);
    } catch (err) {
        console.error(`Error reading ${key}`, err);
        return null;
    }
}

export function setItemToExamStorage(key, value, isRealExam) {
    try {
        getExamStorage(isRealExam).setItem(key, JSON.stringify(value));
    } catch (err) {
        console.error(`Error setting ${key}`, err);
    }
}
